var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMarker = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "58EBB2B9-AFA4-4B82-90B7-F2EB892C960E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,19 L3,19 L3,2 L21,2 L21,19 L14.5,19 L12,21.5 L9.5,19 Z M19,17 L19,4 L5,4 L5,17 L10,17 L12,19 L14,17 L19,17 Z M10,12.5 L10,8.5 L14,8.5 L14,12.5 L10,12.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-wiki-Details",
    transform: "translate(-1261.000000, -219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-topic",
    transform: "translate(100.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing",
    transform: "translate(1140.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_marker",
    transform: "translate(18.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FF5000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_marker.4d3d6a788d589a21bff7873d3727e849.svg";